var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinBloginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.074 5.866c.698.758 1.047 1.798 1.047 3.122v5.833h-3.042V9.399c0-.668-.173-1.187-.519-1.556-.346-.37-.812-.555-1.395-.555s-1.05.184-1.395.555c-.346.37-.52.888-.52 1.556v5.422H6.192V4.836h3.06V6.16c.31-.44.727-.79 1.252-1.046.525-.257 1.115-.385 1.771-.385 1.169 0 2.103.38 2.8 1.137zM1.445 2.969a1.606 1.606 0 01-.533-1.227c0-.487.178-.914.533-1.246C1.801.166 2.26 0 2.821 0c.562 0 1.003.166 1.358.496.356.33.533.747.533 1.246 0 .5-.178.896-.533 1.227-.356.33-.808.496-1.358.496-.549 0-1.02-.166-1.376-.496zm2.968 1.896V15H1.21V4.865h3.203z",
    fill: "#1C2631"
  })));
}

export default SvgLinkedinBloginline;